import { LinkOverrides } from '../types';

export const fiservLinksOverrides: LinkOverrides = {
  helpCenter: 'https://paybillsbymelio.zendesk.com/hc/en-us',
  failedToCollectSupport:
    'https://paybillsbymelio.zendesk.com/hc/en-us/articles/5339224613020-Resolving-unsuccessful-payments-in-Pay-Bills',
};
